import React from "react";
import Accordion from "react-bootstrap/Accordion";

const Section4 = () => {
  const AccordionData = [
    {
      id: "0",
      head: "What exactly is financial reconciliation?",
      body: "It's the process of matching your sales, payouts, and bank deposits across platforms like DoorDash and UberEats to ensure accuracy.",
    },
    {
      id: "1",
      head: "How quickly does Voosh detect discrepancies?",
      body: "Voosh identifies discrepancies instantly and highlights them clearly, enabling rapid corrections.",
    },
    {
      id: "2",
      head: "Can Voosh integrate with my existing accounting tools?",
      body: "Yes, Voosh integrates seamlessly with major accounting platforms including Restaurant365, QuickBooks, and NetSuite.",
    },
    {
      id: "3",
      head: "Is my financial data secure with Voosh?",
      body: "Absolutely. Voosh uses advanced encryption(SOC2) and secure practices to protect your financial data at all times.",
    },
  ];
  return (
    <div className="s4-fin-reco f-width m-auto">
      <div className="">
        <p className="fs-md">FAQ's</p>
        <Accordion defaultActiveKey="0" flush>
          {AccordionData.map((data, index) => (
            <Accordion.Item eventKey={data.id} key={index}>
              <Accordion.Header>
                <strong className="fs-sm fw-bold">{data.head}</strong>
              </Accordion.Header>
              <Accordion.Body style={{ color: "#00000070" }}>
                {data.body}
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </div>
    </div>
  );
};

export default Section4;
